<template>

	<div>
		<b-form-input/>
	</div>

</template>

<script>
	export default {}
</script>